import React from "react";
import { classNameFilter } from "../../utils/ComponentHelpers";
const SkeletonLoader = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNameFilter(className, "grow animate-pulse bg-gray-300")
  });
};
export { SkeletonLoader };